import xssFilter from '~/utils/xss-filter';

const parseGptConversation = ({ comment }: { comment: any }) => {
  const commentData = [];
  const message = xssFilter(comment.body);
  if (comment.author_id !== '') {
    commentData.push({
      msg: xssFilter(message),
      timestamp: new Date(comment.created_at).getTime(),
      nick: 'agent',
      displayName: 'agent',
    });
  } else {
    commentData.push({
      msg: message,
      timestamp: new Date(comment.created_at).getTime(),
      nick: 'visitor',
      displayName: 'visitor',
    });
  }
  return commentData;
};

export default parseGptConversation;
